module.exports = __webpack_public_path__ + "img/truckTrailerFrontLeftOutline.71f18502.svg";